import "../assets/css/filter.scss";
import { svgLibrary } from "./utilities/svg_library";
import { Link } from "react-router-dom";

export function filterPosts(filter, allPosts) {
  if (filter.sort == "occurrence") {
    allPosts.sort((a, b) => (a.occurrence_date < b.occurrence_date ? 1 : -1));
  } else if (filter.sort == "created") {
    allPosts.sort((a, b) => (a.created < b.created ? 1 : -1));
  } else if (filter.sort == "changed") {
    allPosts.sort((a, b) => (a.changed < b.changed ? 1 : -1));
  }

  let filtered = allPosts;
  if (filter.category !== "") {
    filtered = filtered.filter((post) =>
      post.categories.includes(filter.category),
    );
  }
  if (filter.featured_post) {
    filtered = filtered.filter((post) => post.featured_post === "True");
  }
  return filtered;
}

export function PostsFilter({ params }) {
  console.log(params, params.filter);

  let postCategories = params.allPosts.map((post) => post.categories);
  postCategories = postCategories.flat();
  postCategories = [...new Set(postCategories)];
  postCategories.splice(
    postCategories.findIndex((pc) => {
      pc == "";
    }),
  );
  postCategories.sort();
  postCategories.unshift("-- None --");

  function handleFilterChange(key, val) {
    params.setFilter({ ...params.filter, [key]: val });
  }

  return (
    <>
      {/* <div className="posts-filter-toggle-wrapper"> */}
      <div className="filter-toggle">
        <span
          onClick={() =>
            document
              .getElementsByClassName("posts-filter-wrapper")[0]
              .classList.toggle("open")
          }
        >
          {svgLibrary.sort}
        </span>
      </div>
      <div className="posts-filter-wrapper">
        <div className="filter-item">
          <label htmlFor="featured_post">Featured</label>
          <div className="filter-checkbox">
            <input
              type="checkbox"
              name="featured_post"
              onChange={(e) =>
                handleFilterChange("featured_post", e.target.checked)
              }
            />
          </div>
        </div>
        <div className="filter-item">
          <label htmlFor="category">Category</label>
          <select
            name="category"
            onChange={(e) => handleFilterChange("category", e.target.value)}
          >
            {postCategories.map((category, index) => {
              if (category == "-- None --") {
                return (
                  <option key={index} value="">
                    {category}
                  </option>
                );
              }
              return (
                <option key={index} value={category.replaceAll(" ", "_")}>
                  {category}
                </option>
              );
            })}
          </select>
        </div>
        <div className="filter-item">
          <label htmlFor="sort">Sort</label>
          <select
            name="sort"
            onChange={(e) => handleFilterChange("sort", e.target.value)}
          >
            <option value="occurrence">Newly Happened</option>
            <option value="created">Newly Written</option>
            <option value="changed">Newly Edited</option>
          </select>
        </div>
        <div className="navbar-button-wrapper">
          <Link className="button" to={`/parry_news/shinies/`}>
            Shinies ✨
          </Link>
        </div>
      </div>
    </>
  );
}
